// ═══════════════════════════════════════════════════════════════════
// TMS GAMMA — Rastreio automático no navegador (#326, #331, #336)
//
// O robô (Edge Function rastreio-ssw) grava em rastreio_ssw o que achou no
// site de rastreio de cada transportadora. Aqui ficam as duas leituras que a
// tela faz disso: que entregas e transportadoras aplicar nas notas, e quantos
// alertas mostrar.
// ═══════════════════════════════════════════════════════════════════
import { diaUtilAnterior, getValAtual, temOverrideManual } from "./negocio";
import { brParaISO } from "./formatters";
import { normCodTransp } from "./transpLookup";

// Sites que o robô sabe consultar (transportadoras.rastreio). Site novo
// entra aqui, no check da coluna e num tradutor em supabase/functions/_shared.
export const SITES_RASTREIO = {
  ssw:   "SSW",
  troca: "Grupo Troca",
  risso: "Risso",
  alfa:  "Alfa",
  simpliroute: "SimpliRoute",  // frota própria (#344)
};

export const ALERTAS_SSW = {
  sem_info:  "Sem informação no rastreio",
  devolucao: "Possível devolução",
  // #344: a SimpliRoute fechou a visita como entrega parcial — falta entregar o resto.
  parcial:   "Entrega parcial — realizar a entrega completa",
  atraso:    "Possível atraso constatado no rastreio — cobrar transportadora",
  // #342: sem CT-e na SEFAZ, embarcada há mais de 1 dia — provavelmente não carregou.
  sem_cte:   "Sem CT-e emitido",
};

/**
 * Embarque lançado tarde na frota própria (#369, regra do usuário): entrega
 * da SimpliRoute anterior ao embarque, com embarque diferente da emissão →
 * embarque = 1 dia útil antes da entrega, nunca antes da emissão. "" quando
 * não se aplica — inclusive entrega antes da emissão, que é data impossível.
 */
export function embarquePelaEntrega(r, n, ctx) {
  const entISO = brParaISO(r.entrega), embISO = brParaISO(n.dataEmbarque), emiISO = n.dataISO || "";
  if (r.site !== "simpliroute" || !entISO || !embISO || !emiISO) return "";
  if (embISO <= entISO || embISO === emiISO || entISO < emiISO) return "";
  const anterior = diaUtilAnterior(entISO, ctx);
  return brParaISO(anterior) < emiISO ? emiISO.split("-").reverse().join("/") : anterior;
}

/**
 * O que o rastreio muda nas notas ainda sem entrega, no formato de linha que
 * processarEntregas (NotasFiscais) lê: [numero, serie, "dd/mm/aaaa" | "",
 * codTransp | "", embarque ajustado "dd/mm/aaaa" | ""].
 *
 * - Entrega: a data que o site deu.
 * - Transportadora (#336): a que o site diz ter a nota, quando é outra que a
 *   vigente. Nota com troca MANUAL fica de fora — quem trocou sabia algo, e
 *   processarEntregas só a reportaria a cada abertura da tela.
 *
 * Nota que já tem entrega fica de fora: lá, uma data diferente abriria o
 * diálogo de sobrescrita toda vez que alguém abrisse a tela. Devolvida e
 * desconsiderada também — o robô já não as consulta, e a linha antiga não
 * pode trazê-las de volta.
 */
export function entregasDoSsw(rastreio, notas, ctxFeriado = () => ({})) {
  const porNota = new Map((rastreio || []).filter(r => r.entrega || r.transp_detectada).map(r => [r.nota_id, r]));
  if (!porNota.size) return [];
  return (notas || [])
    .filter(n => porNota.has(n.id) && !n.dataEntregaReal &&
                 n.statusNF !== "devolvida" && n.statusNF !== "desconsiderada")
    .map(n => {
      const r = porNota.get(n.id);
      const troca = r.transp_detectada && !temOverrideManual(n, "codTranspUsada") &&
        normCodTransp(r.transp_detectada) !== normCodTransp(getValAtual(n, "codTranspUsada"))
        ? r.transp_detectada : "";
      return [n.numero, n.serie, r.entrega || "", troca, embarquePelaEntrega(r, n, ctxFeriado(n))];
    })
    .filter(([, , entrega, troca]) => entrega || troca);
}

/** Uma contagem por alerta (ALERTAS_SSW) — o robô já limpa o alerta da nota resolvida. */
export function contarAlertasSsw(rastreio) {
  const conta = Object.fromEntries(Object.keys(ALERTAS_SSW).map(k => [k, 0]));
  (rastreio || []).forEach(r => { if (r.alerta in conta) conta[r.alerta]++; });
  return conta;
}
